export default "__VITE_ASSET__f6_0etea__"